import { render, staticRenderFns } from "./service-support.vue?vue&type=template&id=ed3b15a4&"
import script from "./service-support.vue?vue&type=script&lang=js&"
export * from "./service-support.vue?vue&type=script&lang=js&"
import style0 from "./service-support.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports